export default __webpack_public_path__ + "static/media/Naima.5fbd0cd9.png";